import { styled, alpha } from '@mui/material/styles';
import { Box, Card, Button } from '@mui/material';

export const DetailsContainer = styled(Box)(({ theme }) => ({
  maxWidth: '1400px',
  margin: '0 auto',
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  }
}));

export const DetailsCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  background: alpha(theme.palette.background.paper, 0.8),
  backdropFilter: 'blur(10px)',
  borderRadius: theme.shape.borderRadius * 2,
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.05)}`,
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: `0 6px 25px ${alpha(theme.palette.common.black, 0.1)}`,
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  }
}));

export const ImageGallery = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: theme.spacing(2),
  '& .image-container': {
    position: 'relative',
    aspectRatio: '16/9',
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.1)}`,
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.02)',
      '& .image-label': {
        opacity: 1,
      }
    }
  },
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
  },
  '& .image-label': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: theme.spacing(1),
    background: alpha(theme.palette.background.default, 0.85),
    color: theme.palette.text.primary,
    opacity: 0,
    transition: 'opacity 0.3s ease',
    backdropFilter: 'blur(4px)',
  }
}));

export const DetailsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: theme.spacing(3),
  '& .detail-item': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(2),
    background: alpha(theme.palette.background.default, 0.4),
    borderRadius: theme.shape.borderRadius,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      background: alpha(theme.palette.background.default, 0.6),
    }
  }
}));

export const BackButton = styled(Button)(({ theme }) => ({
  alignSelf: 'flex-start',
  marginBottom: theme.spacing(3),
  padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius * 2,
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
  }
}));

// Add these new styled components for property and timeline sections
export const PropertyCard = styled(DetailsCard)(({ theme }) => ({
  '& .details-grid': {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  '& .detail-item': {
    padding: theme.spacing(2),
    background: alpha(theme.palette.background.default, 0.4),
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  '& label': {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  '& span': {
    fontSize: '1rem',
    fontWeight: 500,
  }
}));

export const TimelineCard = styled(DetailsCard)(({ theme }) => ({
  '& .timeline-grid': {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  '& .timeline-item': {
    padding: theme.spacing(2),
    background: alpha(theme.palette.background.default, 0.4),
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  }
}));